<section
  class="vm-row vm-tile-section"
  [id]="data?.id"
  [ngClass]="{
  center:
    data?.type === globalElementType.TileCenterAlignedWhiteBg ||
    data?.type === globalElementType.TileCenterAlignedWhiteBgClick,
    right: 
    data?.type === globalElementType.TileRightAlignWhiteBg ||
    data?.type === globalElementType.TileRightAlignWhiteBgClick,
}">
  <h2 *ngIf="data?.title">
    {{ data?.title }}
  </h2>
  <vm-markdown *ngIf="data?.copy" [data]="data?.copy"></vm-markdown>
  <vm-custom-tile-with-fa-icon-small-section [tiles]="data?.items"></vm-custom-tile-with-fa-icon-small-section>
</section>
